import { FetchFn, Notice, PrometheusQuerySpec, QueryMetadata } from '@/core';
import { GetDataResponse, QueryPluginContext, SeriesName } from '@/plugin-system';
import { MatrixData, RangeQueryResponse } from '@/prometheus-plugin/model';

export type GetDataMethod = (
  spec: PrometheusQuerySpec,
  ctx: QueryPluginContext,
  additionalHeaders?: Record<string, string>,
  fetchFn?: FetchFn
) => Resp;

type ResponseType = GetDataResponse<
  'Distribution' | 'TimeSeries' | 'HeatMap' | 'SingleValue' | 'SingleValueTimeSeries' | 'Table'
>;

type Resp = Promise<ResponseType>;

export type ResponseHandlerFn<T extends Resp | ResponseType = Resp | ResponseType> = (
  result: MatrixData['result'],
  metadata: QueryMetadata,
  notices: Notice[],
  context: ResultContext
) => T;

export type ResponseHandler = Record<ResultType, ResponseHandlerFn>;

export enum ResultType {
  NativeHistogram = 'NativeHistogram',
  TimeSeriesHistogram = 'TimeSeriesHistogram',
  TimeSeries = 'TimeSeries',
}

export interface ResultContext {
  start: number;
  end: number;
  step: number;
  query: string;
  alias: string;
  series_name: SeriesName;
  series_name_format?: string;
  spec?: PrometheusQuerySpec;
  compareResult?: MatrixData['result'];
  compareDurationInMs?: number;
  runRangeQuery?: (moreHeaders?: Record<string, string>) => Promise<RangeQueryResponse>;
  resultsAreFromRangeQuery?: boolean;
  response?: RangeQueryResponse;
  hasTruncationStrategySet?: boolean;
  isStacked?: boolean;
}
